/* cc-staffel-hint.js — klik-gedrag van de "Aantal verhogen"-knop in de
   staffelkorting-hint (snippets/cc-staffel-hint.liquid).

   De hint wordt server-side gerenderd op twee plekken:
   - cart-pagina (sections/main-cart-items.liquid, binnen <cart-items>)
   - ajax-drawer (snippets/cart-item.liquid, binnen <cart-notification>)

   Dit script laadt daarom globaal (snippets/scripts-tag.liquid) en
   gebruikt één gedelegeerde listener op document: beide carts vervangen
   hun item-HTML volledig bij elke update (cart.js vervangt .js-contents,
   de drawer vervangt #form-mini-cart innerHTML), dus directe listeners
   op de knop zouden dat niet overleven.

   Werking: aantal in één klik naar de staffelgrens zetten en een
   bubbelend 'change' event afvuren. Dat event vangt op de cart-pagina
   <cart-items> (theme cart.js) en in de drawer <cart-notification>
   (product.min.js) — beide doen daarop de /cart/change call en de
   server-side re-render, waarna de hint vanzelf verdwenen is als de
   grens bereikt is. */
(function () {
  'use strict';

  if (document._ccStaffelBound) return;
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.cc-staffel-hint-btn');
    if (!btn) return;
    // .cart-item is de item-root in beide carts: <li class="cart-item
    // cc-cart-item"> op de cart-pagina, <div class="cart-item ..."> in
    // de drawer.
    const item = btn.closest('.cart-item');
    const input = item && item.querySelector('input[name="updates[]"]');
    if (!input) return;
    let value = parseInt(btn.dataset.ccStaffelTarget, 10);
    if (isNaN(value) || value < 1) return;
    // Voorraad-clamp: nooit boven het max van de qty-input (= voorraad).
    const max = parseInt(input.max, 10);
    if (!isNaN(max) && max > 0 && value > max) value = max;
    // Nooit omlaag: heeft de klant al meer dan de grens, dan doen we niets.
    const current = parseInt(input.value, 10) || 1;
    if (value <= current) return;
    input.value = value;
    // 'change' bubbelt naar <cart-items> (cart-pagina) of
    // <cart-notification> (drawer); die doen de /cart/change call +
    // server-side re-render. qty-limits.js (ook een change-listener)
    // clampt/snapt de waarde zo nodig eerst naar een geldige step —
    // de theme-listeners zijn gedebounced en lezen de waarde daarna.
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
  document._ccStaffelBound = true;
})();
